export function parsePhoneList(text) {
  if (!text) return [];
  return Array.from(
    new Set(
      text
        .split(/\r?\n|,/)
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => line.replace(/[^\d+]/g, ''))
        .filter((phone) => phone.replace('+', '').length >= 8)
    )
  );
}
